import styles from './BriefHeader.module.css';

/**
 * Top header band of the flight brief: a centered logo over a primary
 * bottom border. The logo is passed as `children` so the caller controls
 * which asset/markup is rendered.
 * @param {object} props
 * @param {React.ReactNode} props.children - Logo content.
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function BriefHeader({ children, className = '' }) {
  return (
    <header className={`${styles.header} ${className}`}>
      <div className={styles.logo}>{children}</div>
    </header>
  );
}

export default BriefHeader;
